import { createSlice } from "@reduxjs/toolkit";


export const attachmentSlice = createSlice({
    name:"AttachmentsSlice",
    initialState:{
        transcriptURL:"",
        voucherURL:"",
        studentCNIC_URL:"",
        parentsCNIC_URL:"",
        proofOfIncomeURL:"",
        electricBillURL:""
    },
    reducers:{
        setTranscriptURL: (state,action)=>{
            state.transcriptURL = action.payload;
        },
        setVoucherURL:(state,action)=>{
            state.voucherURL = action.payload;
        },
        setStudentCNIC_URL: (state,action)=>{
            state.studentCNIC_URL = action.payload;
        },
        setParentsCNIC_URL: (state,action)=>{
            state.parentsCNIC_URL= action.payload;
        },
        setProofOfIncomeURL: (state,action)=>{
            state.proofOfIncomeURLroofOfIncomeURL= action.payload;
        },
        setElectricBillURL: (state,action)=>{
            state.electricBillURL= action.payload;
        },
    }
})

export const {
    setTranscriptURL,
    setVoucherURL,
    setStudentCNIC_URL,
    setParentsCNIC_URL,
    setProofOfIncomeURL,
    setElectricBillURL
} = attachmentSlice.actions;

export default attachmentSlice.reducer;
